<div class="px-3 bg-white py-2 -row m-0 d-flex align-items-center justify-content-between w-100"
    style="border-bottom: 1px solid #DEE8F1;box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.08);">
    <div class="d-flex position-relative button-toggle-container">
        <button class="buttonlist-toggle fs-16 fw-700" style="right: 10px;top:10px;z-index: 3;color: #313A44" (click)="show_popup()">
            {{selectedDisputes == 0 ? 'All Disputes' : (selectedDisputes == 3 ? 'Submitted Disputes' : (selectedDisputes
            == 4 ?
            'Need More Documents' : selectedDisputes == 1 ? 'New Disputes' : selectedDisputes == 2 ? 'Pending Disputes' : selectedDisputes == 5 ? 'Verified'
            : 'All Disputes'))}}
            <img class="ms-2 px-2 mt-1 image_class d-inline" [ngClass]="{'image_active': popup == true}"
                src="assets/img/svg/dropdown-arrow.svg" />
            <div class="bg-white position-absolute button-list-view" *ngIf="popup">
                <div class="border-bottom p-2 f-c-p-1 fw-700 pointer"
                    (click)="offset=0;selectedDisputes=0;getcontractList();">
                    All Disputes <img src="assets/img/png/green-check.png" class="pull-right"
                        [ngClass]="[selectedDisputes == 0 ? 'd-inline':'d-none']" alt="">
                </div>
                <div class="border-bottom p-2 f-c-p-1 fw-700 pointer"
                    (click)="offset=0;selectedDisputes=1;getcontractList();">
                    New Disputes <img src="assets/img/png/green-check.png" class="pull-right"
                        [ngClass]="[selectedDisputes == 1 ? 'd-inline':'d-none']" alt="">
                </div>
                <div class="border-bottom p-2 f-c-p-1 fw-700 pointer"
                    (click)="offset=0;selectedDisputes=2;getcontractList();">
                    Pending Disputes <img src="assets/img/png/green-check.png" class="pull-right"
                        [ngClass]="[selectedDisputes == 2 ? 'd-inline':'d-none']" alt="">
                </div>
                <div class="border-bottom p-2 f-c-p-1 fw-700 pointer"
                    (click)="offset=0;selectedDisputes=3;getcontractList();">
                    Submitted Disputes <img src="assets/img/png/green-check.png" class="pull-right"
                        [ngClass]="[selectedDisputes == 3 ? 'd-inline':'d-none']" alt="">
                </div>
                <div class="border-bottom p-2 f-c-p-1 fw-700 pointer"
                    (click)="offset=0;selectedDisputes=4;getcontractList();">
                    Need More Documents <img src="assets/img/png/green-check.png" class="pull-right"
                        [ngClass]="[selectedDisputes == 4 ? 'd-inline':'d-none']" alt="">
                </div>
                <div class="border-bottom p-2 f-c-p-1 fw-700 pointer"
                    (click)="offset=0;selectedDisputes=5;getcontractList();">
                    Verified <img src="assets/img/png/green-check.png" class="pull-right"
                        [ngClass]="[selectedDisputes == 5 ? 'd-inline':'d-none']" alt="">
                </div>
                <!-- <div class="border-bottom p-2 f-c-p-7 fw-700 pointer">
                        Need More Documents
                    </div> -->
            </div>
        </button>
    </div>
    <div style="width: fit-content;">
        <div class="search_container" style="max-width:300px;width:100%;">
            <input type="text" class="input_field pt-3 pb-3 ps-3 w-100 search-box col-12" [(ngModel)]="searchString"
                (keydown.enter)="searchContract();" required style="min-width: 300px;" placeholder="Search" />
            <label><img src="assets/img/svg/search-normal.svg"> </label>
            <span class="clear_search" [ngClass]="searchString?'d-block':'d-none'" (click)="searchClear()">
                <img src="assets/img/svg/search-cross.svg">
            </span>
        </div>
    </div>
</div>

<ng-container>
    <div class="row mx-0">
        <div class="col-12 py-2 px-1" *ngIf="contractData && contractData.length > 0">
            <table class="w-100 px-2 bg-white">
                <thead>
                    <tr class="border-bottom">
                        <th class="p-3">S.No.</th>
                        <th class="p-3">Customer Information</th>
                        <th class="p-3">Disputed Date</th>
                        <th class="p-3">Contract / Payment /Subscription Id</th>
                        <th class="p-3">Status</th>
                        <th class="p-3">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let contract of contractData;let i=index;">
                        <td class="p-3">{{i + 1 + offset}}</td>
                        <td class="p-3">
                            <div>
                                <h6 class="mb-0 fw-800 f-c-p-8">{{contract.patient_name}}</h6>
                                <p class="mb-0 f-c-p-1">{{contract.patient_email}}</p>
                            </div>
                        </td>
                        <td class="p-3">
                            <p class="mb-0 f-c-p-1 notranslate">{{contract.last_dispute_date | date: "MM/dd/yyyy"}}</p>
                        </td>
                        <td class="p-3">
                            <a href="javascript:void(0)" (click)="viewContract(contract,contract.payment_process_code ? 1 : 0)"
                                class="f-c-p-5 fw-400">{{contract.contract_code || contract.payment_process_code || contract.pp_subscription_code}}
                            </a>
                        </td>
                        <td class="p-3">
                            <p class="mb-0 text-danger text-capitalize"
                                *ngIf="contract.status && contract.status.code ==  1">{{contract.status.status}}</p>
                            <p class="mb-0 text-warning text-capitalize"
                                *ngIf="contract.status && contract.status.code == 2">{{contract.status.status}}</p>
                            <p class="mb-0 text-success text-capitalize"
                                *ngIf="contract.status && contract.status.code == 3">{{contract.status.status}}</p>
                            <p class="mb-0 text-danger text-capitalize"
                                *ngIf="contract.status && contract.status.code ==  4">{{contract.status.status}}</p>
                            <p class="mb-0 text-success text-capitalize"
                                *ngIf="contract.status && contract.status.code ==  5">{{contract.status.status}}</p>
                        </td>
                        <td class="p-3">
                            <p class="color-blue mb-0 f-c-p-5 fw-700">
                                <span class="pointer"
                                    (click)="getContractDetailsDisputes(contract)">
                                    View Details
                                </span><span *ngIf="contract.status && contract.status.code !== 3">
                                    <img [src]="contract.status && contract.status.code == 2 ? 'assets/img/svg/exclamatory_yellow.svg':'assets/img/svg/exclamatory_red.svg'"
                                        alt="" class="d-inline px-2">
                                </span>
                            </p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="w-100 bg-light">
                <mat-paginator [length]="totalRecords" [pageSize]="10" [hidePageSize]="true" [pageIndex]="offset/10"
                    (page)="changePage($event.pageIndex);" class="pagination-style"></mat-paginator>
            </div>
        </div>
        <div class="col-12" *ngIf="!contractData || contractData.length == 0">
            <app-no-data *ngIf="!contractData || contractData.length == 0" [desc]="'No Data Found'"
                [showimg]="1"></app-no-data>
        </div>
    </div>
</ng-container>